import { render, staticRenderFns } from "./delas-freres.vue?vue&type=template&id=2b4166dc&scoped=true"
import script from "./delas-freres.vue?vue&type=script&lang=js"
export * from "./delas-freres.vue?vue&type=script&lang=js"
import style0 from "./delas-freres.vue?vue&type=style&index=0&id=2b4166dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4166dc",
  null
  
)

export default component.exports